window.addEventListener('DOMContentLoaded', () => {
    const selects = document.getElementsByClassName('wpcf7-select');
    for (let i = 0; i < selects.length; i++) {
        let isOpen = false;
        selects[i].addEventListener('click', function() {
            isOpen = !isOpen;
            if (isOpen) {
                selects[i].style.backgroundImage = "url('/wp-content/themes/lukla/assets/dist/svgs/chevron-indigo-up.svg')";
            } else {
                selects[i].style.backgroundImage = "url('/wp-content/themes/lukla/assets/dist/svgs/chevron-indigo-down.svg')";
            }
        });
    }
});
